import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";


export default function Card({ title, right, children }) {
  const { user } = useContext(AuthContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isRetailerMobile =
    Number(user?.role) === 5 && isMobile;

  return (
    <div
      className={`rounded-2xl p-5 transition-all duration-300 ${
        isRetailerMobile
          ? "bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
          : "border border-blue-100 bg-white shadow-lg"
      }`}
    >
      <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
        <div>
          <p
            className={`text-base font-semibold ${
              isRetailerMobile
                ? "text-slate-900"
                : "text-slate-900"
            }`}
          >
            {title}
          </p>
        </div>
        {right}
      </div>

      <div className={isRetailerMobile ? "text-black" : ""}>
        {children}
      </div>
    </div>
  );
}